import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import storefront from "../helpers/storefront";
import * as queries from "../helpers/storefront/queries";
import BlogCard from "../main-blog/blog-card";
import useBlogCardHeights from "../helpers/useBlogCardHeights";

const PAGINATE_BY = 50;

const shuffle = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export default function RelatedArticlesContent({ data }) {
  const { exclude } = data;
  const [articles, setArticles] = useState([]);
  const [trackHeight, cardContentHeight] = useBlogCardHeights();

  useEffect(() => {
    storefront
      .request({
        query: queries.getArticles,
        variables: {
          blogHandle: data.blogHandle,
          first: PAGINATE_BY,
          sortKey: "PUBLISHED_AT",
          reverse: false,
          after: null,
          query: data.tag ? `tag:${data.tag}` : null,
        },
      })
      .then(({ data }) => {
        setArticles([
          ...shuffle(data.blog.articles.edges)
            .map((edge) => edge.node)
            .filter((node) => node.handle !== exclude)
            .slice(0, 4),
        ]);
      });
  }, [data.tag, data.exclude]);

  return (
    <>
      <h2>
        <a
          className="h3 related-articles__heading"
          href={`${data.blogUrl}/tagged/${window.handleize(data.tag)}`}
        >{`More from “${data.tag}”...`}</a>
      </h2>
      <div className="related-articles__articles">
        {articles.map((article) => (
          <BlogCard
            article={article}
            trackHeight={(height) => trackHeight({ id: article.id, height })}
            minHeight={cardContentHeight}
            key={article.handle}
          />
        ))}
      </div>
    </>
  );
}
